/** Audience tags for team documents (matches backend sopController). */
export const SOP_AUDIENCE_OPTIONS = [
  { value: 'all', label: 'All teams' },
  { value: 'developer', label: 'Developer' },
  { value: 'tester', label: 'QA / Tester' },
  { value: 'designer', label: 'Designer' },
  { value: 'devops', label: 'DevOps' },
  { value: 'analyst', label: 'Business Analyst' },
  { value: 'product', label: 'Product' },
  { value: 'lead', label: 'Team Lead' },
  { value: 'manager', label: 'Manager' },
  { value: 'marketing', label: 'Sales & Marketing' },
  { value: 'marketing_manager', label: 'Marketing Manager' },
  { value: 'pr_manager', label: 'PR Manager' },
  { value: 'marketing_designer', label: 'Designer' },
  { value: 'trainee', label: 'Trainee' },
];

export function sopAudienceLabel(value) {
  const v = String(value || 'all').toLowerCase();
  return SOP_AUDIENCE_OPTIONS.find((o) => o.value === v)?.label || v;
}
